import { useEffect, useState } from 'react';
import { isUpgradePopupEnabled } from '../../utils/upgradePopupMode';


interface ConsumerExtensionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ConsumerExtensionModal({ isOpen, onClose }: ConsumerExtensionModalProps) {
  const [showUpgradePopup, setShowUpgradePopup] = useState(false);



  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChromeDownload = () => {
	    if (isUpgradePopupEnabled()) {
      setShowUpgradePopup(true);
    } else {
      window.open('https://chromewebstore.google.com/detail/biomail-bioverifier/jgbpooaoafoefkplcfkeiolociiigjhk', '_blank');
    }

  };



  const handleFirefoxDownload = () => {
    if (isUpgradePopupEnabled()) {
      setShowUpgradePopup(true);
    } else {
      window.open('https://addons.mozilla.org/firefox/addon/qboverifier-consumer', '_blank');
    }
  };

  const closeUpgradePopup = () => {
    setShowUpgradePopup(false);
  };

  return (
    <>

          <div

        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4"
        onClick={onClose}
      >
        <div 
          className="bg-white rounded-2xl overflow-hidden shadow-2xl max-w-4xl w-full"
          style={{ maxHeight: '90vh' }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div 
            className="flex items-center justify-between px-8 py-6 relative"
            style={{ backgroundColor: '#29B3E6' }}
          >
            <h2 className="text-3xl font-bold text-white">
              Install Chrome Extension
            </h2>
            <button 
              onClick={onClose}
              className="absolute top-4 right-4 bg-red-600 hover:bg-red-700 text-white transition-colors cursor-pointer w-8 h-8 flex items-center justify-center rounded"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>

          {/* Content */}
          <div className="p-8">
            <p className="text-lg text-gray-600 text-center mb-8">
              Click below to install the QBOVerifier Consumer Extension
            </p>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
              {/* Chrome Card */}
              <div 

                className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-blue-300 hover:shadow-lg transition-all cursor-pointer group"
								onClick={handleChromeDownload}
              >
                <div className="text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                    <img 
                      src="https://static.readdy.ai/image/60cfa5760427af1c3d73f4665d1a36c9/7b2ff160e9a0472896e12837b8f9136d.png"
                      alt="Chrome Logo"
                      className="w-16 h-16 object-contain"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Google Chrome</h3>
                  <p className="text-gray-600 mb-6">
                    Install QBOVerifier Consumer Extension for Chrome to verify invoice authenticity with a single click.
                  </p>
                  <div className="flex items-center justify-center gap-2 text-blue-600 group-hover:text-blue-700 transition-colors">
                    <i className="ri-download-line text-xl"></i>
                    <span className="font-semibold">Install Extension</span>
                  </div>
                </div>
							</div>


              {/* Firefox Card - Hidden */}
              {/*
              <div 
                className="bg-white border-2 border-gray-200 rounded-xl p-8 hover:border-gray-300 hover:shadow-lg transition-all cursor-pointer group"
                onClick={handleFirefoxDownload}
              >
                <div className="text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-blue-50 rounded-full flex items-center justify-center group-hover:bg-blue-100 transition-colors">
                    <img 
                      src="https://static.readdy.ai/image/60cfa5760427af1c3d73f4665d1a36c9/cff54c948ffdb3bd9d4780cb0e0adf6a.png"
                      alt="Firefox Logo"
                      className="w-16 h-16 object-contain"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Mozilla Firefox</h3>
                  <p className="text-gray-600 mb-6">
                    Install QBOVerifier Consumer Extension for Firefox to instantly verify invoices and protect yourself from fraud.
                  </p>
                  <div className="flex items-center justify-center gap-2 text-blue-600 group-hover:text-blue-700 transition-colors">
                    <i className="ri-download-line text-xl"></i>
                    <span className="font-semibold">Install Extension</span>
                  </div>
                </div>
              </div>
              */}
            </div>

            {/* Additional Info */}
            <div className="mt-8 p-6 bg-gray-50 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-information-line text-green-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Installation Requirements</h4>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li>• Chrome browser (version 88 or higher)</li>
                    <li>• Free to install and use</li>
                    <li>• Verify any invoice with a QBOVerifier stamp instantly</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upgrade In Progress Popup (Firefox fallback) */}
      {showUpgradePopup && (
        <div 
          className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] px-4"
          onClick={closeUpgradePopup}
        >
          <div 
            className="bg-white rounded-2xl overflow-hidden shadow-2xl max-w-md w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div 
              className="flex items-center justify-between px-6 py-4 relative"
              style={{ backgroundColor: '#29B3E6' }}
            >
              <h3 className="text-2xl font-bold text-white">
                Upgrade In Progress
              </h3>
              <button 
                onClick={closeUpgradePopup}
                className="absolute top-3 right-3 bg-red-600 hover:bg-red-700 text-white transition-colors cursor-pointer w-8 h-8 flex items-center justify-center rounded"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="p-8 text-center">
              <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-5xl" style={{ color: '#29B3E6' }}></i>
              </div>
              <p className="text-lg text-gray-700 mb-4">
                We&apos;re currently upgrading this feature to serve you better.
              </p>
              <p className="text-gray-600">
                Please check back soon!
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}